<h1 mat-dialog-title *ngIf="!nonComcast">Power supply created with name {{powerSupplyName}}</h1>
<h1 mat-dialog-title *ngIf="nonComcast">Power supply created with name {{powerSupplyName}} and it will be reviewed and accepted</h1>
<mat-dialog-actions class="d-flex justify-content-center">
  <button mat-button type="button" (click)="onclickOK()">OK</button>
</mat-dialog-actions>